<template>
  <div class="audios">
    <div class="row">
      <div class="col-md-4">
        <el-upload
          ref="audioFilesUploader"
          class="audio-files"
          drag
          :headers="apiHeaders"
          :action="apiAudios"
          multiple
          accept="audio/mp3"
          name="audio"
          :file-list="audioFiles"
          auto-upload
          :on-success="handleSuccess"
          :on-error="handleUploadError"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <p class="mb-0">
              Suelta tus archivos aquí o
              <em class="text-primary">haz clic para cargar</em>.
            </p>
            <p class="mb-0 text-muted">Archivos .mp3 con un tamaño menor de 20Mb</p>
          </div>
        </el-upload>
        <p class="mt-3">
          <button v-if="clearFilesEnabled" class="btn btn-primary" @click="clearFiles">
            <i class="far fa-trash-alt"></i> Limpiar
          </button>
        </p>
      </div>
      <div class="col-md-8">
        <el-table
          class="mt-3"
          v-loading="loadingAudiosS3"
          :data="audiosS3"
          :default-sort="{prop: 'id', order: 'descending'}"
        >
          <el-table-column prop="id" label="ID" width="75px" sortable></el-table-column>
          <el-table-column label="Creado">
            <template slot-scope="scope">{{ scope.row.created | moment('DD/MM/YYYY HH:mm:ss') }}</template>
          </el-table-column>
          <el-table-column label="Actualizado">
            <template slot-scope="scope">{{ scope.row.updated | moment('DD/MM/YYYY HH:mm:ss') }}</template>
          </el-table-column>
          <el-table-column prop="audio" label="Audio" align="right">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.audio" placement="top-end">
                <a :href="scope.row.audio" class="text-secondary">
                  <i class="fas fa-headphones"></i>
                </a>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { APIENDPOINT } from "@/backend";
export default {
  name: "Audios",

  components: {},

  data() {
    return {
      loadingAudiosS3: false,
      apiAudios: APIENDPOINT + "/api/v1/audios",
      apiHeaders: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
      },
      msg: "Utilidad para subir los archivos de audio",
      audiosS3: "",
      audioFiles: [],
      clearFilesEnabled: false
    };
  },

  mounted() {
    this.getAudios();
  },

  methods: {
    getAudios() {
      this.loadingAudiosS3 = true;
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/audios"
      })
        .then(response => {
          if (response.data.code === 0) {
            this.audiosS3 = response.data.data.audios;
            // console.group("getAudios:");
            // console.log(this.getAudios);
            // console.groupEnd();
          }
        })
        .catch(e => {
          this.errors.push(e);
        })
        .finally(() => (this.loadingAudiosS3 = false));
    },

    handleSuccess(response, file) {
      console.log(response, file);
      this.clearFilesEnabled = true;
      this.getAudios();
    },

    handleUploadError(msg, file) {
      console.log("Fail Msg:", msg);
      console.log("File Details", file);

      if (msg.status !== 404) {
        this.$notify.error({
          title: "Error en subida",
          message: "No se ha podido subir el archivo [" + file.name + "]",
          duration: 0
        });
      } else {
        this.$notify.error({
          title: "Path Not Found",
          message: "No such path on the server to upload to",
          duration: 0
        });
      }
    },

    clearFiles() {
      this.$refs.audioFilesUploader.clearFiles();
      this.clearFilesEnabled = false;
    }
  },

  computed: {}
};
</script>

<style>
</style>
